import { default as local } from "./urls-local.json";
import { default as test } from "./urls-test.json";
import { default as stage } from "./urls-stage.json";
import { default as production } from "./urls-production.json";

declare global {
  interface Window {
    environment: IEnvironment;
  }
}

interface IEnvironment {
  name: "local" | "test" | "stage" | "production";
}

interface IConfig {
  COMPLIANCE_API_URL: string;
  KYCP_AUTH_API_URL: string;
  SERVICE_LINE_CHECK_API_URL: string;
  CONNECT_API_URL: string;
  UPP_CONNECT_API_URL: string;
  envName?: string;
  IS_lOCIZE_ENABLED: boolean;
  REACT_QUERY_DEBUG_MODE: boolean;
  UPP_SEARCH_URL: string;
  MY_LOGIN_URL: string;
  UPP_SEARCH_API_URL: string;
}

const initConfig = (): IConfig => {
  const envName = window.environment?.name ?? "local"; // default provided for tests
  switch (envName) {
    case "local":
      return local;
    case "test":
      return test;
    case "stage":
      return stage;
    case "production":
      return production;
    default:
      return local;
  }
};

const config = initConfig();

export default config;
